import { DbListReceipts } from "../../../data/usecases/list-receipts";
import { ListReceipts } from "../../../domain/usecases/list-receipts";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbListReceipt = (): ListReceipts =>
  new DbListReceipts(
    makeApiUrl("/receipt"),
    makeAuthorizeHttpClientDecorator()
  );
